var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex" },
    [
      _c(
        "div",
        { staticClass: "flex flex-col mr-2" },
        [_c("CardItemTitle", { attrs: { title: _vm.title } })],
        1
      ),
      _vm._t("default", function () {
        return [
          _c(
            "div",
            { staticClass: "flex flex-col max-w-full truncate" },
            [
              _c("CardItemValue", {
                attrs: {
                  value: _vm.value,
                  highlighted: _vm.highlightValue,
                  routeParams: _vm.routeParams,
                },
              }),
            ],
            1
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }